module.exports = "<p>\n  fx-grid-lite works!\n</p>\n"